import { render, staticRenderFns } from "./ValidationAlert.vue?vue&type=template&id=8827db72&scoped=true"
import script from "./ValidationAlert.vue?vue&type=script&lang=js"
export * from "./ValidationAlert.vue?vue&type=script&lang=js"
import style0 from "./ValidationAlert.vue?vue&type=style&index=0&id=8827db72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8827db72",
  null
  
)

export default component.exports